import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { TabSlide as ITabSlide } from "@app/components/base-page/models";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { Carousel } from "./components/carousel/Carousel";

type Props = {
  slides: ITabSlide[];
};

export const TabSlideSwitcher: FC<Props> = ({ slides }) => (
  <div
    className={classNames(
      "mt-20 px-5",
      "lg:mt-25 lg:px-16",
      "xl:mx-auto xl:mt-40 xl:w-full xl:max-w-container-wide xl:px-24",
    )}
  >
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <Carousel slides={slides} />
    </Fade>
  </div>
);
